import React, { Fragment } from 'react';
import { Badge, Box, Button, Checkbox, CircularProgress, Collapse, Divider, FormControl, Grid, Grow, IconButton, InputAdornment, MenuItem, Popover, SnackbarContent, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { CustomButton, CustomCheckbox, CustomInputLabel, CustomSearch, CustomSelect, CustomTextField, FlexDiv, InputProps, SelectInputProps, StyledCard, StyledCardTitle } from '../../../../../custom/components';
import styles from 'custom/style.module.css';
import manifestStyles from './manifest.module.css';
import flightStyles from '../../flightsfolder.module.css';
import theme from 'custom/theme';
import { AddIcon, DeleteIcon, EcoIcon, PageIcon, UploadIcon, DateTimeSecFormat, DateFormat } from 'custom/constants';
import { Close, CloseFullscreen, Delete, FilterList, OpenInFull, PlaylistAdd, Refresh, Save, Search, Warning } from '@mui/icons-material';
import PDFSliderManifest from './PDFSliderManifest';
import cookies from 'utils/cookies';
import ManifestSummaryContainer from '../../summary/ManifestSummaryContainer';
import DuplicateAwbModal from './DuplicateAwbModal';
import Download from './downloadawb/Download';
import { dateTolocale } from 'utils/converter';
import MessageModal from './MessageModal';
import moment from 'moment';
import ConfirmDialog from 'components/pages/common/ConfirmDialog';

const getuldweight = (awbs) => {
  let weight = 0;
  let unit = awbs[0]?.weight_unit || 'K';
  awbs.forEach(awb => {
    if (awb.wgt) {
      weight = (parseFloat(weight) + parseFloat(awb.wgt)).toFixed(1);
    }
  });
  return weight + unit;
};
const partShiopment = (awb, ulds) => {
  // console.log('ULDs', ulds, awb?.awb_no);
  let pcs = awb?.pcs ? parseInt(awb.pcs) : 0;
  let wgt = awb?.wgt ? parseFloat(awb.wgt) : 0;
  let part = false;
  ulds.forEach((uld) => {
    uld?.flight_awbs?.forEach((item) => {
      // console.log('Item', item.awb_no, item.pcs, item.id, awb.awb_no, awb.id);
      if (item.awb_no === awb.awb_no && awb.id !== item.id) {
        part = true;
        pcs += parseInt(item.pcs);
        wgt += parseFloat(item.wgt);
      }
    });
  });
  // console.log('Part Shipment pcs', pcs, 'Part', part);
  return {
    pcs,
    wgt: wgt ? wgt.toFixed(2) : 0,
    part
  };
};
const disablefields = cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent' ? true : false;

const Manifest = (props) => {

  const fullScreenStyles = {
    mt: 2,
    width: props.fullscreen ? 'calc(100vw - 44px)' : 'auto',
    height: props.fullscreen ? 'calc(100vh - 44px)' : 'auto',
    maxHeight: props.fullscreen ? '100vh' : 'auto',
    transition: 'all 0.5s ease-in-out',
    position: props.fullscreen ? 'fixed' : 'relative',
    top: props.fullscreen ? 6 : 'auto',
    left: props.fullscreen ? 22 : 'auto',
    zIndex: props.fullscreen ? 1300 : 'auto',
    opacity: '1 !important',
    visibility: 'visible !important',
    transform: 'scale(1) !important',
  };

  return (
    <>
      {/* <CustomCheckbox
        control={
          <Checkbox inputProps={{ 'aria-label': 'manifest', }} checked={props.nil} onChange={props.onChangeNil} name='view_manifest'
            sx={{
              paddingTop: '6px',
              paddingBottom: '6px',
              color: '#fff',
              '&.Mui-checked': { color: '#fff', },
            }}
            size='small'
          />
        }
        className={`${manifestStyles.whiteCheckbox} ${manifestStyles.nilCheckbox}`}
        classes={{ label: manifestStyles.whiteCheckboxLabel }}
        label={'NIL'}
      /> */}
      <Grid container spacing={3} className={manifestStyles.hidePrint} sx={{ marginTop: props.showRejectedMessage || props.showNilMessage ? '38px' : '0' }}>
        <Grid item xs={12} className={styles.pt0}
          sx={{
            [`& .${flightStyles.summaryCollapse}`]: {
              marginTop: '-36px !important',
              transition: 'margin-top 0.3s ease-in-out',
            },
            [`& .${flightStyles.summaryShow}`]: {
              marginTop: '-24px !important',
              transition: 'margin-top 0.3s ease-in-out',
            }
          }}>
          <ManifestSummaryContainer nil={props.nil_manifest} handleFilter={props.handleFilter} showReportModal={props.showReportModal} />
        </Grid>
        {
          props.is_empty && (
            <Grid item xs={12} className={styles.pt0}>
              <SnackbarContent
                classes={{
                  root: styles.errorSnackbar,
                  message: styles.errorSnackbarMessage,
                }}
                message={(
                  <Stack direction={'column'} justifyContent={'center'} alignItems={'center'}>
                    <Typography variant='body2' component='span' color='error' textAlign={'center'} display={'flex'} alignItems={'center'} textTransform={'capitalize'} fontWeight={'bold'}>
                      <Warning sx={{ fontSize: 20 }} color='error' /> &nbsp; Required fields are missing information.</Typography>
                    <Typography variant='caption' component='span' color='#000000b5'>
                      Please review the manifest details to update the fields.
                    </Typography>
                  </Stack>
                )}
              />
            </Grid>
          )
        }
        <ConfirmDialog
          title='Confirm Action'
          confirmDialog={props.dis_alert}
          onClose={props.onCloseAlert}
          confirmationMessage='
          Notification is sent to all concerned parties.
          This action will update the manifest data. Do you want to proceed?'
          handleConfirm={props.handleConfirm}
        />
        <Grid item xs={12} className={`${props.is_empty ? '' : styles.pt0}`}>
          <Grow in={props.fullscreen} style={{ transformOrigin: '0 0 0' }}
            {...(props.fullscreen ? { timeout: 1000 } : {})}>
            <Box sx={fullScreenStyles}>
              <StyledCard className={`${props.nil_manifest ? styles.cardOverlay : ''} ${props.fullscreen ? styles.h100 : ''} ${styles.positionRelative}`}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md='auto' order={{
                    xs: 1,
                    sm: 1,
                    md: 1,
                    lg: 1,
                    xl: 1
                  }}>
                    <FlexDiv>
                      <StyledCardTitle>
                        <Stack direction='row' alignItems='center'>
                          Manifest Details
                          {props.fullscreen ?
                            props.ffm && ` - ${props.ffm?.airline?.code}${props.ffm?.flight_no}/${moment(props.ffm.flight_date).format(DateFormat).toUpperCase()}`
                            : null}
                          <Divider orientation='vertical' flexItem sx={{
                            margin: '0 10px',
                            backgroundColor: '#ffffff8f',
                            height: '20px',
                            marginLeft: '30px',
                          }} />
                          <Fragment>

                            <IconButton
                              size='small'
                              disableRipple
                              disableElevation
                              title='Refresh'
                              classes={{
                                startIcon: styles.mauto,
                                disabled: styles.disabledIconImg
                              }}
                              onClick={props.onRefresh}
                              disabled={!props.doc || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                              color='primary'
                            >
                              <Refresh sx={{ fontSize: 18 }} />
                            </IconButton>

                            <IconButton
                              color='primary'
                              size='small'
                              disableRipple
                              disableElevation
                              title={props.fullscreen ? 'Exit Fullscreen' : 'Fullscreen'} className={manifestStyles.collapseIcon} edge='end' onClick={props.handleFullScreenToggle}>
                              {props.fullscreen ? <OpenInFull sx={{ fontSize: 18 }} /> : <CloseFullscreen sx={{ fontSize: 18 }} />}
                            </IconButton>

                            <IconButton
                              color='primary'
                              size='small'
                              disableRipple
                              disableElevation
                              title='Filter' className={manifestStyles.collapseIcon} edge='end' onClick={props.handleToggle}>
                              <Badge variant='dot' color='error' invisible={!props.filter.search}>
                                <FilterList sx={{ fontSize: 18 }} />
                              </Badge>
                            </IconButton>

                            {props.message_logs && props.message_logs?.length > 0 && (<>
                              <Button size='small'
                                title='History'
                                disableElevation
                                disableRipple
                                variant='contained'
                                color='secondary'
                                className={styles.historyIcon}
                                onClick={props.handleHistory}
                                sx={{ ml: 1 }}
                              >H
                              </Button>
                              <Popover
                                open={Boolean(props.anchorEl)}
                                anchorEl={props.anchorEl}
                                onClose={props.handleClose}
                                anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'center',
                                }}
                                transformOrigin={{
                                  vertical: 'top',
                                  horizontal: 'center',
                                }}
                              >
                                <div className={styles.p1}>
                                  {props.message_logs.map((log, index) =>
                                    <Typography key={index} sx={{ p: 1 }} fontSize={'0.78rem'} borderBottom={'1px solid #ececec'} color={props.msg_id == log.id ? '#59B362' : '#000'} onClick={() => props.handleOpen('msg', log)}
                                      className={styles.pointer}>• &nbsp; {log?.type == 'FFM' ? 'PDF' : 'FFM'} Received {dateTolocale(log.created, DateTimeSecFormat)} </Typography>)}
                                </div>
                              </Popover>
                            </>)}
                          </Fragment>
                        </Stack>
                      </StyledCardTitle>
                    </FlexDiv>
                  </Grid>
                  {props.open &&
                    <Grid item xs={12} sm={6} md='auto' lg='auto' xl='auto' order={{
                      xs: 2,
                      sm: 2,
                      md: 2,
                      lg: 2,
                      xl: 2
                    }}>
                      <Collapse in={props.open} orientation='horizontal'>
                        <Stack direction='row' spacing={2} alignItems='center' mb={3} sx={{
                          transform: 'scale(0.9)',
                          marginTop: '-9px',
                          transformOrigin: 'left',
                          marginLeft: '-20px',
                        }}>
                          <CustomSearch
                            id='search'
                            variant='outlined'
                            size='small'
                            type='search'
                            placeholder='Search ULD#, AWB# or SPL Code'
                            name='search'
                            value={props?.filter?.search || ''}
                            onChange={props.onChangeFilter}
                            className={styles.clearSearchIcon}
                            InputProps={{
                              endAdornment: <InputAdornment position='end'>
                                <Stack direction='row' spacing={0} alignItems='center'>
                                  <IconButton title='Clear' onClick={props.clearSearch}>
                                    <Close sx={{ fontSize: 13 }} />
                                  </IconButton>
                                  <IconButton
                                    size='small'
                                    aria-label='search'
                                    edge='end'
                                    onClick={props.filterData}
                                  >
                                    <Search fontSize='inherit' />
                                  </IconButton>
                                </Stack>
                              </InputAdornment>,
                            }}
                            onKeyDown={
                              (e) => {
                                if (e.key === 'Enter') {
                                  props.filterManifestData(true);
                                }
                              }
                            }
                            inputProps={{ 'aria-label': 'search' }}
                          />
                          <CustomSelect
                            {...SelectInputProps}
                            id='handled_as'
                            labelId='handled_as-label'
                            fullWidth
                            autoFocus
                            onChange={props.onChangeFilter}
                            name='handled_as'
                            style={{ width: '120px' }}
                            value={!props?.filter?.handled_as ? 'placeholder' : props.filter.handled_as}
                            classes={{ select: !props.filter?.handled_as ? styles.colorPlaceholder : '' }}
                          >
                            <MenuItem value='placeholder' disabled >Select type</MenuItem>
                            <MenuItem value={'All'}>All</MenuItem>
                            <MenuItem value={'Loose'}>Loose</MenuItem>
                            <MenuItem value={'Intact'}>Intact</MenuItem>
                          </CustomSelect>
                        </Stack>
                      </Collapse>
                    </Grid>
                  }
                  <Grid item xs={12} sm={12} md={12} lg='auto' order={{
                    xs: 3,
                    sm: 3,
                    md: 3,
                    lg: 2,
                    xl: 3
                  }} ml={'auto'}>
                    <Stack direction={'row'} spacing={2} alignItems={'center'} justifyContent='flex-end' flexWrap={'wrap'} mb={3}>
                      {!props.showReportModal && (
                        <CustomCheckbox
                          control={
                            <Checkbox inputProps={{ 'aria-label': 'nil manifest', }} checked={props.nil_manifest} onChange={props.onChangeNilManifest} name='nil_manifest'
                              sx={{ padding: '6px' }}
                              size='small'
                              disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                            />
                          }
                          label={'NIL Manifest'}
                          sx={{ zIndex: 2, }}
                        />)}

                      {props.doc && props.doc?.remark && (<Typography variant='caption' component='span' color='var(--redText)' htmlFor='' className={styles.labelStats}>{props.doc?.remark}</Typography>)}

                      {!props.showReportModal && (
                        <Box className={`${manifestStyles.uploadBtn} ${(props.nil_manifest || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent') ? manifestStyles.uploadBtnDisabled : ''}`}>
                          {props.loadingManifest ?
                            <CircularProgress size='20px' sx={{ color: '#fff' }} /> :
                            <div>
                              <input
                                accept='application/pdf'
                                style={{ display: 'none' }}
                                type='file'
                                id='ffm-file'
                                name='file'
                                onChange={props.handleUpload}
                                disabled={props.nil_manifest || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                className={manifestStyles.upload}
                                ref={props.fileInputRef}
                              />
                              <label htmlFor='ffm-file'
                                onClick={(e) => {
                                  props.ffm.is_notified ? (
                                    !props.can_edit && e.preventDefault(),
                                    props.checkNoti('upload')
                                  ) : {};
                                }}
                                className={`${styles.fs0} ${manifestStyles.uploadIcon} ${props.nil_manifest ? styles.disableIconBtn : ''}`}>
                                <Stack direction='row' spacing={1} alignItems='center'>
                                  <UploadIcon className={`${styles.whiteSvg} ${manifestStyles.uploadIcon}`} />
                                  <Stack direction='column'>
                                    <Typography variant='body2' component='span' textAlign='center'>
                                      Upload Manifest
                                    </Typography>
                                    <Typography id='ffm-note' variant='caption' component='span' fontSize={'9px'} lineHeight='normal' marginTop={'-2px'} className={manifestStyles.uploadedon}
                                    // className={flightStyles.manifestUpload}
                                    ></Typography>
                                  </Stack>
                                </Stack>
                              </label>
                            </div>
                          }
                        </Box>
                      )}

                      {!props.showReportModal && (
                        <CustomButton
                          variant='contained'
                          color='primary'
                          onClick={() => props.handleUld(true)}
                          disabled={props.add_uld || !props.doc || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                          className={manifestStyles.addUldBtn}>
                          <PlaylistAdd
                            sx={{
                              fontSize: '1.4rem',
                              color: props.add_uld ? '#bdbdbd' : '#dfe3e8',
                              marginRight: '4px',
                            }}
                          /> Add ULD</CustomButton>
                      )}
                      <Badge badgeContent={props.noScanAwbs.length} color='error'>
                        <Download
                          manifestData={props.manifestData}
                          flightInfo={props.flightInfo}
                          airlineCode={props.ffm?.airline?.code}
                          filename={'Awbs List'}
                          title='Print no scan list'
                          disabled={!props.doc || props.showReportModal}
                          airlineLogo={props.airlineLogo}
                        />
                      </Badge>
                    </Stack>
                  </Grid>
                </Grid>
                <Box sx={{ maxHeight: props.fullscreen ? (props.open ? 'calc(var(--contentBox) - 75px)' : 'calc(var(--contentBox) - 12px)') : 'calc(var(--contentBox) - 230px)', }}
                  className={`${styles.overflowAutoWrapper}`}>
                  <Grid container spacing={3}>
                    {props.add_uld ? (<Grid item container spacing={2}>
                      <Grid item container xs={12} lg={12} alignItems={'center'} spacing={2} className={styles.mt1}>
                        <Grid item xs={12} sm={6} md={3} lg={1.75}>
                          <CustomInputLabel htmlFor='' aria-label='Type' className={styles.ipLabel}>Type</CustomInputLabel>
                          <FormControl fullWidth>
                            <CustomSelect
                              {...SelectInputProps}
                              id=''
                              size='small'
                              type='select'
                              name='c_type'
                              value={props.uldFields?.c_type}
                              className={`${styles.smInput}`}
                              onChange={props.onChangeUld}
                            >
                              <MenuItem value={'ULD'}>ULD</MenuItem>
                              <MenuItem value={'BULK'}>BULK</MenuItem>
                            </CustomSelect>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={1.17}>
                          <CustomInputLabel htmlFor='' aria-label='uld_no' className={styles.ipLabel}>ULD No</CustomInputLabel>
                          <CustomTextField
                            {...InputProps}
                            id=''
                            fullWidth
                            placeholder='ULD No'
                            type='text'
                            name='uld_no'
                            onChange={props.onChangeUld}
                            disabled={props.uldFields?.c_type == 'BULK'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={1.17}>
                          <CustomInputLabel id='handled_as' aria-label='Select handled as' className={styles.ipLabel}>Handled as</CustomInputLabel>
                          <FormControl fullWidth>
                            <CustomSelect
                              {...SelectInputProps}
                              id='handled_as'
                              name='type'
                              classes={{ input: manifestStyles.smSelect }}
                              value={props.uldFields?.type}
                              onChange={props.onChangeUld}
                            >
                              <MenuItem value={'Loose'}>Loose</MenuItem>
                              <MenuItem value={'Intact'}>Intact</MenuItem>
                            </CustomSelect>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={1.16}>
                          <CustomInputLabel id='segment' aria-label='Select Segment' className={styles.ipLabel}>Segment</CustomInputLabel>
                          <FormControl fullWidth>
                            <CustomSelect
                              {...SelectInputProps}
                              id='segment'
                              name='segment'
                              classes={{ input: manifestStyles.smSelect }}
                              value={props.uldFields?.segment}
                              onChange={props.onChangeUld}
                              // disabled={props.uldFields?.type == 'Loose'}
                            >
                              <MenuItem value={'Import'}>Import</MenuItem>
                              <MenuItem value={'Export'}>Export</MenuItem>
                              <MenuItem value={'Transit'}>Transit</MenuItem>
                            </CustomSelect>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={1.75}>
                          <CustomInputLabel htmlFor='' aria-label='Enter Select ' className={styles.ipLabel}>ULD Type</CustomInputLabel>
                          <FormControl fullWidth>
                            <CustomSelect
                              {...SelectInputProps}
                              id=''
                              name='uld_type'
                              classes={{ input: manifestStyles.smSelect }}
                              value={props.uldFields?.uld_type}
                              onChange={props.onChangeUld}
                              // disabled={props.uldFields?.type == 'Loose'}
                            >
                              <MenuItem value={'LD3'}>LD3</MenuItem>
                              <MenuItem value={'2X LD3'}>2X LD3</MenuItem>
                              <MenuItem value={'LD7'}>LD7</MenuItem>
                              <MenuItem value={'MD'}>MD</MenuItem>
                              <MenuItem value={'2X MD'}>2X MD</MenuItem>
                            </CustomSelect>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={11} lg={4}>
                          <CustomInputLabel htmlFor='' aria-label='Enter Select ' className={styles.ipLabel}>Remarks</CustomInputLabel>
                          <CustomTextField
                            {...InputProps}
                            id=''
                            value={props.uldFields?.remark}
                            onChange={props.onChangeUld}
                            fullWidth
                            placeholder='Remarks'
                            type='text'
                            name='remark'
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={1} lg={1}>
                          <Stack direction='row' spacing={1} justifyContent='center' alignItems={'flex-end'} className={styles.mt1}>
                            <IconButton onClick={props.onAddUld}>
                              <Save color='primary' fontSize={'4rem'} />
                            </IconButton>
                            <div className={`${manifestStyles.actionIconsLg} ${styles.p2}`}>
                              <DeleteIcon onClick={() => props.handleUld(false)} />
                            </div>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>) : null
                    }
                    <Grid item container spacing={3}>
                      {props.filteredManifestData && props.filteredManifestData?.map((uld, uldindex) => {
                        return (<>
                          <Grid item xs={12}>
                            <div className={manifestStyles.uldWrapper}>
                              <>
                                <Grid container alignItems={'center'} spacing={2}>
                                  <Grid item xs={12} md={12} lg={3} xl={5} display={'flex'} gap={2}>
                                    <Typography variant='h6' component='h6' color={theme.palette.primary.main}
                                      fontWeight={'bold'} fontSize={'14px'} textAlign={'left'} pl={2}>
                                      {`${uld?.uld_no} | ${uld?.flight_awbs?.length} Awbs | ${getuldweight(uld?.flight_awbs)}`}</Typography>
                                  </Grid>
                                  <Grid item xs={'auto'} minWidth={150} flexDirection={'row'} display={'flex'}>
                                    <CustomInputLabel id='handled_as' aria-label='Select handled as' className={`${styles.ipLabel} ${manifestStyles.noWrap} ${manifestStyles.headerLabel}`}>Handled as</CustomInputLabel>
                                    <FormControl fullWidth ref={(el) => (props.rowRefs[uld.id] = el)}>
                                      <CustomSelect
                                        {...SelectInputProps}
                                        id='handled_as'
                                        name='type'
                                        classes={{
                                          root: manifestStyles.manifestHeaderIp,
                                          input: manifestStyles.smSelect,
                                          select: manifestStyles.manifestHeaderIpSelect
                                        }}
                                        // style={{ width: '200px' }}
                                        value={uld?.type}
                                        // onChange={(e) => props.onChange(e, uld.id, null)}
                                        onChange={(e) => props.checkHandledAs(e, uld.id, null)}
                                        disabled={disablefields || props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                      >
                                        <MenuItem value={'Loose'}>Loose</MenuItem>
                                        <MenuItem value={'Intact'}>Intact</MenuItem>
                                      </CustomSelect>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={'auto'} minWidth={170} flexDirection={'row'} display={'flex'}>
                                    <CustomInputLabel id='segment' required aria-label='Select Segment' className={`${styles.ipLabel} ${manifestStyles.noWrap} ${manifestStyles.headerLabel}`}>Segment</CustomInputLabel>
                                    <FormControl fullWidth>
                                      <CustomSelect
                                        {...SelectInputProps}
                                        id='segment'
                                        name='segment'
                                        classes={{
                                          root: manifestStyles.manifestHeaderIp,
                                          input: manifestStyles.smSelect,
                                          select: manifestStyles.manifestHeaderIpSelect
                                        }}
                                        // style={{ width: '200px' }}
                                        value={uld?.segment}
                                        onChange={(e) => props.onChange(e, uld.id, null)}
                                        disabled={disablefields || uld?.type == 'Loose' || props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                        error={!uld?.segment}
                                      >
                                        <MenuItem value={'Import'}>Import</MenuItem>
                                        <MenuItem value={'Export'}>Export</MenuItem>
                                        <MenuItem value={'Transit'}>Transit</MenuItem>
                                      </CustomSelect>
                                    </FormControl>
                                  </Grid>
                                  <Grid item xs={'auto'} minWidth={170} flexDirection={'row'} display={'flex'}>
                                    <CustomInputLabel htmlFor='' aria-label='Enter Select' className={`${styles.ipLabel} ${manifestStyles.noWrap} ${manifestStyles.headerLabel}`}>ULD Type</CustomInputLabel>
                                    <FormControl fullWidth>
                                      <CustomSelect
                                        {...SelectInputProps}
                                        id=''
                                        name='uld_type'
                                        classes={{
                                          root: manifestStyles.manifestHeaderIp,
                                          input: manifestStyles.smSelect,
                                          select: manifestStyles.manifestHeaderIpSelect
                                        }}
                                        value={uld?.uld_type}
                                        // style={{ width: '200px' }}
                                        onChange={(e) => props.onChange(e, uld.id, null)}
                                        disabled={disablefields || props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                      >
                                        <MenuItem value={'LD3'}>LD3</MenuItem>
                                        <MenuItem value={'2X LD3'}>2X LD3</MenuItem>
                                        <MenuItem value={'LD7'}>LD7</MenuItem>
                                        <MenuItem value={'MD'}>MD</MenuItem>
                                        <MenuItem value={'2X MD'}>2X MD</MenuItem>
                                      </CustomSelect>
                                    </FormControl>
                                  </Grid>
                                  <Grid item minWidth={200} xs flexDirection={'row'} display={'flex'}>
                                    <CustomInputLabel htmlFor='remarks' aria-label='Enter remarks' className={`${styles.ipLabel} ${manifestStyles.noWrap} ${manifestStyles.headerLabel}`}>Remarks</CustomInputLabel>
                                    <CustomTextField
                                      {...InputProps}
                                      id='remarks'
                                      name='remarks'
                                      fullWidth
                                      // autoFocus
                                      placeholder='Remarks'
                                      type='text'
                                      value={props?.uld_remarks?.[uld.id] ? props?.uld_remarks?.[uld.id] : uld?.remark}
                                      onChange={(e) => props.onChange(e, uld.id, null)}
                                      onBlur={() => props.onChange({
                                        target: {
                                          name: 'sub_remark',
                                          value: null,
                                        }
                                      }, uld.id, null)}
                                      InputProps={{
                                        disableUnderline: true,
                                        classes: {
                                          root: manifestStyles.awbIpRoot,
                                          input: manifestStyles.awbIp
                                        },
                                      }}
                                      className={manifestStyles.awbIpTextfield}
                                      disabled={disablefields || props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                    />
                                  </Grid>
                                  <Grid item xs={'auto'} flexDirection={'row'} display={'flex'}>
                                    <Divider orientation='vertical' flexItem className={manifestStyles.uldButtonDivider} />
                                  </Grid>
                                  <Grid item xs='auto'>
                                    <Stack direction='row' spacing={1} justifyContent='center' alignItems={'center'}>
                                      <AddIcon title='Add AWB' className={`${styles.actionIcons} ${manifestStyles.smallIcon} ${styles.p0}`} onClick={() => props.handleAwb(uld.id)} disabled={props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'} />
                                      {(props.edit &&
                                        <div className={`${styles.actionIcons} ${styles.fs0}`}>
                                          <DeleteIcon onClick={(e) => props.deleteUld(uld.id, e.currentTarget)} disabled={props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'} />
                                        </div>)}
                                    </Stack>
                                  </Grid>
                                </Grid>
                              </>
                            </div>
                            <div>
                              <TableContainer className={manifestStyles.manifestDetails} sx={{ background: props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent' ? '#ddd' : '#fff' }}>
                                <Table className={manifestStyles.manifestTable}>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell colSpan={8}></TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {uld.flight_awbs && uld.flight_awbs?.length > 0 && uld.flight_awbs.map((awb/*, awbindex*/) => {
                                      let partInfo = partShiopment(awb, props.manifestData);
                                      return (<>
                                        <TableRow classes={{ root: manifestStyles.firstRow }} >
                                          <TableCell ref={(el) => (props.columnRef.awb_no[uldindex] = el)} width={props.columnWidth.awb_no} sx={{ minWidth: 140 }} align='left'>
                                            <IconButton disableRipple className={`${styles.p0} ${manifestStyles.manifestIcons} ${!awb?.awbId ? styles.disabledImg : ''}`} disabled={!awb?.awbId} onClick={() => awb?.awbId ? props.handleOpen('view_awb', awb) : (!awb?.awbId && awb?.awb_conflict ? props.handleOpen('awb', awb) : {})}>
                                              {
                                                awb?.spl_code && (awb?.spl_code?.includes('EAP') || awb?.spl_code?.includes('EAW')) ?
                                                  <div className={`${manifestStyles.actionIconsLg}`}>
                                                    <EcoIcon />
                                                  </div>:
                                                  <div className={`${manifestStyles.docIcon}`}>
                                                    <PageIcon />
                                                  </div>
                                              }
                                            </IconButton>
                                            {!props.edit ? awb.awb_no : (
                                              <CustomTextField
                                                {...InputProps}
                                                key={awb.id}
                                                fullWidth
                                                placeholder='AWB No'
                                                type='text'
                                                name='awb_no'
                                                onFocus={() =>props.checkNoti('input')}
                                                defaultValue={awb?.awb_no}
                                                onBlur={(e) => props.onChange(e, awb?.awb_no, awb.id)}
                                                className={`${manifestStyles.awbCellIp} ${manifestStyles.tableIpTextfield}`}
                                                disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                                InputProps={{
                                                  classes: {
                                                    root: manifestStyles.tableIpRoot,
                                                    input: manifestStyles.tableIp,
                                                    disabled: manifestStyles.disabledIp
                                                  },
                                                }}
                                              />
                                            )}
                                          </TableCell>
                                          <TableCell ref={(el) => (props.columnRef.org_dest[uldindex] = el)} width={props.columnWidth.org_dest} sx={{ minWidth: 100 }} align='center'>
                                            {!props.edit ? `${awb?.org}-${awb?.dest}` : (
                                              <>
                                                <input type='text' key={awb.id + 'ORG'} name='org' defaultValue={awb?.org} onBlur={(e) => props.onChange(e, awb?.org, awb.id)} className={`${styles.smInput} ${manifestStyles.orgdest} ${awb?.org ? '' : manifestStyles.emptyInput}`} disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'} />
                                                -
                                                <input type='text' key={awb.id + 'DEST'} name='dest' defaultValue={awb?.dest} onBlur={(e) => props.onChange(e, awb?.dest, awb.id)} className={`${styles.smInput} ${manifestStyles.orgdest} ${awb?.dest ? '' : manifestStyles.emptyInput}`} disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'} />
                                              </>
                                            )}</TableCell>
                                          <TableCell ref={(el) => (props.columnRef.pcs[uldindex] = el)}
                                            width={props.columnWidth.pcs}
                                            sx={{
                                              minWidth: 100,
                                              display: 'flex',
                                            }}
                                            align='center'>
                                            <div className={`${manifestStyles.pcsInputWrapper}`}>
                                              {!props.edit ? awb.pcs : (
                                                <input type='number' key={awb.id + 'PCS'} name='pcs' defaultValue={awb?.pcs} onBlur={(e) => props.onChange(e, awb?.pcs, awb.id)} className={`${manifestStyles.pcsIp} ${awb?.pcs ? '' : manifestStyles.emptyInput}`} disabled={props.disableFlightFields} />
                                              )}{partInfo?.part ? '/ ' + partInfo.pcs + '\u00A0' + '\u00A0' : ''} &nbsp;
                                            </div>
                                          </TableCell>
                                          <TableCell
                                            ref={(el) => (props.columnRef.wgt[uldindex] = el)}
                                            width={props.columnWidth.wgt}
                                            align='center'
                                          >
                                            <div className={`${manifestStyles.wgtInputWrapper}`}>
                                              {!props.edit ? (awb.wgt ? parseFloat(awb?.wgt) : '0') : (
                                                <input type='number' key={awb.id + 'WGT'} name='wgt' defaultValue={awb?.wgt} onBlur={(e) => props.onChange(e, awb?.wgt, awb.id)} className={`${styles.smInput} ${manifestStyles.wgtIp} ${awb?.wgt ? '' : manifestStyles.emptyInput}`} disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'} />
                                              )}{partInfo?.part ? '/ ' + partInfo.wgt + '\u00A0' + '\u00A0' : ''} <span>{(awb?.wgt_unit || 'K')} &nbsp; &nbsp;</span></div>
                                          </TableCell>
                                          <TableCell ref={(el) => (props.columnRef.remarks[uldindex] = el)} width={props.columnWidth.remarks} sx={{ minWidth: 200 }}>
                                            {!props.edit ? awb?.remark : (
                                              <CustomTextField
                                                {...InputProps}
                                                key={awb.id + 'REMARK'}
                                                fullWidth
                                                placeholder='Commodity'
                                                type='text'
                                                name='awb_remark'
                                                defaultValue={awb?.remark}
                                                onBlur={(e) => props.onChange(e, awb?.remark, awb.id)}
                                                className={`${styles.commInput} ${manifestStyles.tableIpTextfield}`}
                                                disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                                InputProps={{
                                                  classes: {
                                                    root: manifestStyles.tableIpRoot,
                                                    input: `${manifestStyles.tableIp} ${manifestStyles.leftAlignIp}`,
                                                    disabled: manifestStyles.disabledIp
                                                  },
                                                }}
                                              />
                                            )}</TableCell>
                                          <TableCell ref={(el) => (props.columnRef.spl_code[uldindex] = el)} width={awb?.spl_code?.length > 6 ? '350px' : props.columnWidth.spl_code} sx={{ minWidth: 200 }}>
                                            {!props.edit ? awb?.spl_code : (
                                              <input type='text' key={awb.id + 'SPL'} name='spl_code' defaultValue={awb?.spl_code} onBlur={(e) => props.onChange(e, awb?.spl_code, awb.id)} className={manifestStyles.leftAlignIp} disabled={props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'} />)}
                                          </TableCell>
                                          <TableCell ref={(el) => (props.columnRef.products[uldindex] = el)} width={props.columnWidth.products} sx={{ minWidth: 150 }}>
                                            <CustomSelect
                                              {...SelectInputProps}
                                              id=''
                                              name='productsId'
                                              className={`${styles.smInput} ${manifestStyles.productsIp} ${(awb?.products?.length == 0 && awb?.prod_conflict) ? styles.colorRed : ''}`}
                                              value={awb?.products?.length > 0 ? awb?.products?.map((item) => item.id) : (awb?.prod_conflict ? [9999] : [0])}
                                              onChange={(e) => props.onChange(e, null, awb.id)}
                                              inputProps={{ 'aria-label': 'Without label' }}
                                              disabled={disablefields || props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'}
                                              multiple
                                              fullWidth
                                              classes={{
                                                root: manifestStyles.selectIpRoot,
                                                select: manifestStyles.selectIp,
                                                disabled: manifestStyles.disabledIpSelect
                                              }}
                                            >
                                              {props.productsList.map((item) => {
                                                return (<MenuItem key={item.id} value={item.id}>
                                                  {item.name}
                                                </MenuItem>
                                                );
                                              })}
                                              {awb?.spl_code && awb?.products?.length == 0 && awb.prod_conflict && (<MenuItem key={9999} value={9999}>
                                                Conflict
                                              </MenuItem>)}
                                              {awb.products?.length == 0 && !awb.prod_conflict && (
                                                <MenuItem key={0} value={0}>
                                                  GENERAL
                                                </MenuItem>
                                              )}
                                            </CustomSelect>
                                          </TableCell>
                                          <TableCell>
                                            <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems={'center'}>
                                              {(props.edit && <div className={`${styles.ml3} ${manifestStyles.delIcon}`}>
                                                <DeleteIcon onClick={(e) => props.deleteAwb(awb.id, e.currentTarget)} color='inherit' fontSize='small' disabled={props.showReportModal || props.disableFlightFields || props.isNoOp || cookies.get('role') === 'Airline Rep' || cookies.get('role') === 'GHA Agent'} />
                                              </div>)}
                                            </Stack>
                                          </TableCell>
                                        </TableRow>
                                      </>);
                                    })}
                                    {props.add_awb && uld.id == props.add_awb ? (<TableRow classes={{ root: manifestStyles.firstRow }} >
                                      <TableCell className={styles.minWidth100} align='left'>
                                        <CustomTextField
                                          {...InputProps}
                                          id=''
                                          fullWidth
                                          placeholder='AWB No'
                                          type='text'
                                          name='awb_no'
                                          value={props.awbFields?.awb_no}
                                          onChange={props.onChangeAwb}
                                        />
                                      </TableCell>
                                      <TableCell className={styles.minWidth60} align='center'>
                                        <input type='text' name='org' placeholder='org' className={`${styles.smInput} ${manifestStyles.orgdest}`} value={props.awbFields?.org} onChange={props.onChangeAwb} />
                                        -
                                        <input type='text' name='dest' placeholder='dest' className={`${styles.smInput} ${manifestStyles.orgdest}`} value={props.awbFields?.dest} onChange={props.onChangeAwb} />
                                      </TableCell>
                                      <TableCell className={styles.minWidth40} align='center'>
                                        <input type='number' name='pcs' placeholder='pcs' className={`${styles.smInput} ${manifestStyles.orgdest}`} value={props.awbFields?.pcs} onChange={props.onChangeAwb} />
                                      </TableCell>
                                      <TableCell className={styles.minWidth60} align='center'>
                                        <input type='number' name='wgt' placeholder='wgt' className={`${styles.smInput} ${manifestStyles.orgdest}`} value={props.awbFields?.wgt} onChange={props.onChangeAwb} />
                                      </TableCell>
                                      <TableCell className={styles.minWidth135}>
                                        <CustomTextField
                                          {...InputProps}
                                          id=''
                                          fullWidth
                                          placeholder='Commodity'
                                          type='text'
                                          name='remark'
                                          value={props.awbFields?.remark}
                                          onChange={props.onChangeAwb}
                                        />
                                      </TableCell>
                                      <TableCell className={styles.minWidth125}>
                                        <input type='text' name='spl_code' placeholder='spl' defaultValue='' className={`${manifestStyles.splInput}`} value={props.awbFields?.spl_code} onChange={props.onChangeAwb} />
                                      </TableCell>
                                      <TableCell className={styles.minWidth100}>
                                        <CustomSelect
                                          {...SelectInputProps}
                                          id=''
                                          name='productsId'
                                          className={`${styles.smInput}`}
                                          value={props.awbFields?.productsId || [0]}
                                          onChange={props.onChangeAwb}
                                          inputProps={{ 'aria-label': 'Without label' }}
                                          multiple
                                        >
                                          {props.productsList.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                              {item.name}
                                            </MenuItem>
                                          ))}
                                          <MenuItem key={9999} value={0}>
                                            GENERAL
                                          </MenuItem>
                                        </CustomSelect>
                                      </TableCell>
                                      <TableCell style={{
                                        minWidth: '30px',
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                      }}>
                                        <IconButton
                                          size='small'
                                          aria-label='send'
                                          edge='end'
                                          title='Save AWB'
                                          onClick={props.onAddAwb}
                                        >
                                          <Save fontSize='inherit' />
                                        </IconButton>
                                        <IconButton
                                          size='small'
                                          aria-label='send'
                                          edge='end'
                                          title='Delete AWB'
                                          onClick={() => props.handleAwb(false)}
                                        >
                                          <Delete fontSize='inherit' />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>)
                                      : <></>
                                    }
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </Grid>
                        </>);
                      })}
                    </Grid>
                  </Grid>
                </Box>
              </StyledCard>
            </Box>
          </Grow>
        </Grid>
      </Grid>

      <PDFSliderManifest
        modal={props.modal}
        modal_data={props.modal_data}
        onClose={props.onClose}
      />
      <MessageModal
        modal={props.modal}
        onClose={props.onClose}
        modal_data={props.modal_data}
      />

      <DuplicateAwbModal
        modal={props.modal}
        onClose={props.onClose}
        modal_data={props.modal_data}
        awb_value={props.awb_value}
        onChange={props.onChange}
      />
    </>
  );
};

export default Manifest;